// Copyright (c) 2017 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateAuditSummaryReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

const resetAuditSummaryReport = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_AUDIT_SUMMARY_SUCCESS]: updateAuditSummaryReport,
        [actions.RESET_AUDIT_SUMMARY_REPORT]: resetAuditSummaryReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/audit-summary/reducers/report.js